<template>
  <div class="section-parameter" v-if="infos">
    <div class="col-left">
      <h2>{{ $t('settings.information.title') }}</h2>
    </div>
    <div class="col-right">
      <div class="form-group">
        <label>{{ $t('settings.information.name') }}</label>
        <el-input v-model="infos.name"></el-input>
      </div>
      <div class="form-group">
        <label>{{ $t('settings.information.description') }}</label>
        <el-input type="text" v-model="infos.description"></el-input>
      </div>
      <div class="form-group">
        <label>Url</label>
        <el-input type="text" v-model="infos.url"></el-input>
      </div>
      <div class="form-group">
        <label>{{ $t('settings.information.timezone') }}</label>
        <el-input type="text" v-model="infos.timezone"></el-input>
      </div>
      <div class="form-group">
        <label>{{ $t('settings.information.key') }}</label>
        <label class="tag" >{{ site.secret }}</label>
      </div>
      <div class="form-group">
        <label>DNS Properties</label>
        <div class="checkboxes">
          <el-checkbox v-model="fname">Firstname</el-checkbox>
          <el-checkbox v-model="lname">Lastname</el-checkbox>
          <el-checkbox v-model="email">Email</el-checkbox>
        </div>
      </div>
      <div class="form-group">
        <label>{{ $t('settings.information.encryption') }}</label>
        <div class="checkboxes">
          <el-radio v-model="infos.xuidencryptmode" label="BASE64">BASE64</el-radio>
          <el-radio v-model="infos.xuidencryptmode" label="AES256">AES256</el-radio>
        </div>
      </div>
      <div class="form-submit">
        <el-button plain @click="save">{{ $t('settings.actions.save') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      infos: null,
      fname: false,
      lname: false,
      email: false
    }
  },
  computed: {
    ...mapGetters('account', {
      site: 'currentSite'
    })
  },
  watch: {
    site: function (site) {
      this.init()
    }
  },
  methods: {
    ...mapActions('account', ['updateSite']),
    init () {
      if (this.site) {
        this.infos = Object.assign({}, {
          id: this.site.id,
          name: this.site.name,
          description: this.site.description,
          url: this.site.url,
          timezone: this.site.timezone,
          dnsproperties: this.site.dnsproperties,
          xuidencryptmode: this.site.xuidencryptmode
        })
      }
      if (this.infos.dnsproperties.includes('fname')) {
        this.fname = true
      }
      if (this.infos.dnsproperties.includes('lname')) {
        this.lname = true
      }
      if (this.infos.dnsproperties.includes('email')) {
        this.email = true
      }
    },
    save () {
      this.infos.dnsproperties = []
      if (this.email) {
        this.infos.dnsproperties.push('email')
      }
      if (this.fname) {
        this.infos.dnsproperties.push('fname')
      }
      if (this.lname) {
        this.infos.dnsproperties.push('lname')
      }

      this.updateSite(this.infos).then(() => {
        this.$notify({title: 'Success', message: this.$root.$t('notifications.settings.edited'), type: 'success'})
      }).catch((e) => {
        this.$notify.error({ title: 'Error', message: this.$root.$t('notifications.unknown') })
      })
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss">
label.tag {
    background:#eaeaea;
    color:#565656;
    padding: 8px;
    display: inline-block;
    font-weight: 400;
}

.checkboxes {
  label {
    width: auto;
    display: inline-block !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/settings/settings_about.vue